import locale from "localization/en";

export const nonSaleTransactionColumn = [
  { key: "pump", text: locale.pump, width: "9%" },
  { key: "product", text: locale.product },
  { key: "transactionType", text: locale.transactionType, width: "15%" },
  { key: "referenceNo", text: locale.referenceNo },
  { key: "quantity", text: locale.quantity },
  { key: "amount", text: locale.amount },
  { key: "transactionId", text: locale.transactionNo },
  {
    key: "refName",
    text: (
      <span>
        {locale.refName} /<br />
        {locale.plateNumber}
      </span>
    ),
  },
  { key: "remarks", text: locale.remarks },
];
